module.exports = import("https://js.stripe.com/v3/");;